import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M11.6666 15V14.9896C11.6614 14.9931 11.6562 14.9966 11.651 15H11.6666Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M8.33325 2.5C10.8129 2.5 13.0115 3.70338 14.3769 5.55801C14.7316 6.03976 14.3515 6.66667 13.7532 6.66667C13.4843 6.66667 13.2361 6.53011 13.0709 6.31789C11.9731 4.90735 10.2591 4 8.33325 4C5.01954 4 2.33325 6.68629 2.33325 10C2.33325 13.3137 5.01954 16 8.33325 16C8.77506 16 9.16658 16.3442 9.16658 16.786C9.16658 17.163 8.88286 17.4895 8.50599 17.498C8.44856 17.4993 8.39098 17.5 8.33325 17.5C4.19112 17.5 0.833252 14.1421 0.833252 10C0.833252 5.85786 4.19112 2.5 8.33325 2.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M9.372 11.0495C9.60377 10.8129 9.88955 10.6 10.2208 10.6C10.7476 10.6 11.1439 11.0941 10.8721 11.5455C10.3472 12.417 9.39184 13 8.30029 13C6.64344 13 5.30029 11.6569 5.30029 10C5.30029 8.34315 6.64344 7 8.30029 7C9.39184 7 10.3472 7.58296 10.8721 8.45453C11.1439 8.90587 10.7476 9.4 10.2208 9.4C9.88955 9.4 9.60377 9.18715 9.372 8.95051C9.09973 8.6725 8.72016 8.5 8.30029 8.5C7.47187 8.5 6.80029 9.17157 6.80029 10C6.80029 10.8284 7.47187 11.5 8.30029 11.5C8.72016 11.5 9.09973 11.3275 9.372 11.0495Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M15.5992 17.4998C15.5992 17.4998 12.6824 15.9998 12.6824 12.9998C12.6824 11.1248 13.9324 9.9998 15.5989 9.9998C17.2654 9.9998 18.5157 11.1248 18.5157 12.9998C18.5157 15.75 15.5992 17.4998 15.5992 17.4998Z",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("ellipse", {
  cx: "15.599",
  cy: "12.9165",
  rx: "0.833333",
  ry: "0.833333",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}